export const replaceTemplateValue = (string, value) => {
  if (!string) {
    return "";
  }
  return string.replace("[value]", value);
};
